<div>
  <h1 mat-dialog-title>
    <span>Release Notes</span>
  </h1>
  <div mat-dialog-content>
    <div *ngFor="let releaseNote of releaseNotes" class="notes">
      <ul>
        <div>
          <h2>
            Version {{ releaseNote.version }}
            {{ getCurrentVersion() === releaseNote.version ? ' - (aktuelle Version)' : '' }}
          </h2>
        </div>
        <p>{{ releaseNote.date }}</p>
        <li *ngFor="let change of releaseNote.changes">
          {{ change }}
        </li>
      </ul>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="Ok()" color="warn">Ok</button>
    </div>
  </div>
</div>
